module.exports = __webpack_public_path__ + "img/contact_phone.031ee500.svg";